<template>
  <div class="app-container">
    <list ref="list">
      <template slot="column">
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/business/purchase/inquiryexecution/list";
export default {
  name: "inquiryexecution",
  mixins: [curdMixins],
  components: {
    list,
  },

  computed: {
    canPrice() {
      return this.$permission.canPrice();
    },
  },
  methods: {
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.UserId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>